module.exports = __webpack_public_path__ + "static/media/iconDownloadLastStepHorizontalDone.6dad92d3.svg";